import { z } from 'zod';

export const ruleDescriptionSchema = z.string().max(255, 'Description cannot be longer than 255 characters');
